"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGraphOrders = exports.graphCreatedOrders = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var moment_1 = __importDefault(require("moment"));
var types_1 = require("./types");
var utils_1 = require("./utils");
var getProgress = function (srcFilled, srcAmountIn) {
    if (!srcFilled || !srcAmountIn)
        return 0;
    var progress = (0, bignumber_js_1.default)(srcFilled || "0")
        .dividedBy(srcAmountIn || "0")
        .toNumber();
    return !progress ? 0 : progress < 0.99 ? progress * 100 : 100;
};
var graphCreatedOrders = function (_a) {
    var account = _a.account, endpoint = _a.endpoint, signal = _a.signal;
    return __awaiter(void 0, void 0, void 0, function () {
        var LIMIT, page, orders, fetchOrders;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    LIMIT = 1000;
                    page = 0;
                    orders = [];
                    fetchOrders = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var query, payload, response, orderCreateds;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    query = "\n      {\n      orderCreateds(first: ".concat(LIMIT, ", orderBy: timestamp, skip: ").concat(page * LIMIT, ", where:{maker: \"").concat(account, "\"}) {\n          id\n          Contract_id\n          ask_bidDelay\n          ask_data\n          ask_deadline\n          ask_dstMinAmount\n          ask_dstToken\n          ask_fillDelay\n          ask_exchange\n          ask_srcToken\n          ask_srcBidAmount\n          ask_srcAmount\n          blockNumber\n          blockTimestamp\n          dex\n          dollarValueIn\n          dstTokenSymbol\n          exchange\n          maker\n          srcTokenSymbol\n          timestamp\n          transactionHash\n      }\n  }\n    ");
                                    return [4 /*yield*/, fetch(endpoint, {
                                            method: "POST",
                                            body: JSON.stringify({ query: query }),
                                            signal: signal,
                                        })];
                                case 1:
                                    payload = _a.sent();
                                    return [4 /*yield*/, payload.json()];
                                case 2:
                                    response = _a.sent();
                                    orderCreateds = response.data.orderCreateds;
                                    orders.push.apply(orders, orderCreateds);
                                    if (!(orderCreateds.length >= LIMIT)) return [3 /*break*/, 4];
                                    page++;
                                    return [4 /*yield*/, fetchOrders()];
                                case 3:
                                    _a.sent();
                                    return [3 /*break*/, 5];
                                case 4: return [2 /*return*/, orders];
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); };
                    return [4 /*yield*/, fetchOrders()];
                case 1:
                    _b.sent();
                    return [2 /*return*/, orders];
            }
        });
    });
};
exports.graphCreatedOrders = graphCreatedOrders;
var getOrderStatuses = function (ids, endpoint, signal) { return __awaiter(void 0, void 0, void 0, function () {
    var query, response, payload, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = "\n    {\n        statuses(where:{id_in: [".concat(ids.map(function (id) { return "\"".concat(id, "\""); }), "]}) {\n          id\n          status\n        }\n      }\n      ");
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(endpoint, {
                        method: "POST",
                        body: JSON.stringify({ query: query }),
                        signal: signal,
                    })];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                payload = _a.sent();
                return [2 /*return*/, payload.data.statuses.reduce(function (result, item) {
                        result[item.id] = item.status;
                        return result;
                    }, {})];
            case 4:
                error_1 = _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
var getOrderFills = function (orderId, fills) {
    return {
        TWAP_id: Number(orderId),
        dstAmountOut: fills === null || fills === void 0 ? void 0 : fills.reduce(function (acc, it) { return acc.plus((0, bignumber_js_1.default)(it.dstAmountOut)); }, (0, bignumber_js_1.default)(0)).toString(),
        srcAmountIn: fills === null || fills === void 0 ? void 0 : fills.reduce(function (acc, it) { return acc.plus((0, bignumber_js_1.default)(it.srcAmountIn)); }, (0, bignumber_js_1.default)(0)).toString(),
        dollarValueIn: fills === null || fills === void 0 ? void 0 : fills.reduce(function (acc, it) { return acc.plus((0, bignumber_js_1.default)(it.dollarValueIn)); }, (0, bignumber_js_1.default)(0)).toString(),
        dollarValueOut: fills === null || fills === void 0 ? void 0 : fills.reduce(function (acc, it) { return acc.plus((0, bignumber_js_1.default)(it.dollarValueOut)); }, (0, bignumber_js_1.default)(0)).toString(),
    };
};
var graphOrderFills = function (_a) {
    var account = _a.account, endpoint = _a.endpoint, signal = _a.signal;
    return __awaiter(void 0, void 0, void 0, function () {
        var LIMIT, page, fills, fetchFills;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    LIMIT = 1000;
                    page = 0;
                    fills = [];
                    fetchFills = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var query, payload, response, orderFilleds, grouped;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    query = "\n    {\n      orderFilleds(first: ".concat(LIMIT, ", orderBy: timestamp, skip: ").concat(page * LIMIT, ", where: { userAddress: \"").concat(account, "\" }) {\n        id\n        dstAmountOut\n        dstFee\n        srcFilledAmount\n        TWAP_id\n        srcAmountIn\n        timestamp\n        dollarValueIn\n        dollarValueOut\n      }\n    }\n  ");
                                    return [4 /*yield*/, fetch(endpoint, {
                                            method: "POST",
                                            body: JSON.stringify({ query: query }),
                                            signal: signal,
                                        })];
                                case 1:
                                    payload = _a.sent();
                                    return [4 /*yield*/, payload.json()];
                                case 2:
                                    response = _a.sent();
                                    orderFilleds = (0, utils_1.groupBy)(response.data.orderFilleds, "TWAP_id");
                                    grouped = Object.entries(orderFilleds).map(function (_a) {
                                        var orderId = _a[0], fills = _a[1];
                                        return getOrderFills(orderId, fills);
                                    });
                                    fills.push.apply(fills, grouped);
                                    if (!(orderFilleds.length >= LIMIT)) return [3 /*break*/, 4];
                                    page++;
                                    return [4 /*yield*/, fetchFills()];
                                case 3:
                                    _a.sent();
                                    return [3 /*break*/, 5];
                                case 4: return [2 /*return*/, fills];
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); };
                    return [4 /*yield*/, fetchFills()];
                case 1:
                    _b.sent();
                    return [2 /*return*/, (0, utils_1.keyBy)(fills, "TWAP_id")];
            }
        });
    });
};
var getStatus = function (progress, order, statuses) {
    var _a;
    if (progress === void 0) { progress = 0; }
    var status = (_a = statuses === null || statuses === void 0 ? void 0 : statuses[order.Contract_id]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    if (progress === 100 || status === "completed") {
        return types_1.Status.Completed;
    }
    if (status === "canceled") {
        return types_1.Status.Canceled;
    }
    if ((0, moment_1.default)(Number(order.ask_deadline)).valueOf() > (0, moment_1.default)().valueOf() / 1000) {
        return types_1.Status.Open;
    }
    return types_1.Status.Expired;
};
var getGraphOrders = function (endpoint, account, signal) { return __awaiter(void 0, void 0, void 0, function () {
    var args, _a, orders, fills, ids, statuses, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                args = { account: account, endpoint: endpoint, signal: signal };
                return [4 /*yield*/, Promise.all([(0, exports.graphCreatedOrders)(args), graphOrderFills(args)])];
            case 1:
                _a = _b.sent(), orders = _a[0], fills = _a[1];
                ids = orders.map(function (order) { return order.Contract_id; });
                statuses = {};
                _b.label = 2;
            case 2:
                _b.trys.push([2, 4, , 5]);
                return [4 /*yield*/, getOrderStatuses(ids, endpoint, signal)];
            case 3:
                statuses = _b.sent();
                return [3 /*break*/, 5];
            case 4:
                error_2 = _b.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/, orders.map(function (order) {
                    var orderFill = fills[order.Contract_id];
                    var progress = getProgress(orderFill === null || orderFill === void 0 ? void 0 : orderFill.srcAmountIn, order.ask_srcAmount);
                    return {
                        id: Number(order.Contract_id),
                        exchange: order.exchange,
                        dex: order.dex.toLowerCase(),
                        deadline: Number(order.ask_deadline),
                        createdAt: (0, moment_1.default)(order.timestamp).unix().valueOf(),
                        srcAmount: order.ask_srcAmount,
                        dstMinAmount: order.ask_dstMinAmount,
                        status: getStatus(progress, order, statuses),
                        srcBidAmount: order.ask_srcBidAmount,
                        fillDelay: order.ask_fillDelay,
                        txHash: order.transactionHash,
                        dstAmount: orderFill === null || orderFill === void 0 ? void 0 : orderFill.dstAmountOut,
                        srcFilledAmount: orderFill === null || orderFill === void 0 ? void 0 : orderFill.srcAmountIn,
                        dollarValueIn: orderFill === null || orderFill === void 0 ? void 0 : orderFill.dollarValueIn,
                        dollarValueOut: orderFill === null || orderFill === void 0 ? void 0 : orderFill.dollarValueOut,
                        progress: progress,
                        srcTokenAddress: order.ask_srcToken,
                        dstTokenAddress: order.ask_dstToken,
                        totalChunks: (0, bignumber_js_1.default)(order.ask_srcAmount || 0)
                            .div(order.ask_srcBidAmount || 0)
                            .integerValue(bignumber_js_1.default.ROUND_CEIL)
                            .toNumber(),
                    };
                })];
        }
    });
}); };
exports.getGraphOrders = getGraphOrders;
